import * as React from 'react';
import { SensorTypeInterface } from './shared';
import { inject, observer } from 'mobx-react';
import  { Form, Modal, Icon, Tab } from 'semantic-ui-react';
import uuidv1 from 'uuid/v1';
import './SensorTypeEdit.scss';
import ConfigurationsInput from 'src/components/inputs/ConfigurationsInput';
import Convert from 'convert-units';
import ConditionalState from 'src/components/inputs/ConditionalState';

interface SensorTypeEditProps {
    fromObject: Partial<SensorTypeInterface>;
    resolveRow: (sensorType?: SensorTypeInterface) => any;
    rejectRow: (err?: Error | { isNormal: boolean, typedId: number }) => any;
    isNew?: boolean;
    authStore?: any;
}

let possibleStateOptions = [ 
    'open', 'close', 'low', 'high', 'true', 'false', 'offline', 'online'
].map(o => {return { key: o, value: o, text: o }; });

@inject('authStore')
@observer
export default class SensorTypeEdit extends React.Component<
    SensorTypeEditProps, 
    any
> {
    sensorNameOptions = [];
    resolveRow?: (sensorType?: SensorTypeInterface) => any;
    rejectRow?: (err?: any) => any;
    typedUUID: string;
    constructor(props: SensorTypeEditProps) {
        super(props);
        const { resolveRow, rejectRow, fromObject } = props;
        this.resolveRow = resolveRow;
        this.rejectRow = rejectRow;
        this.typedUUID = fromObject.typedId || uuidv1(); 
        this.state = {
            ...fromObject,
            clientId: fromObject.clientId || this.props.authStore.clientId,
            typedId: fromObject.typedId,
            isStateBased: fromObject.isStateBased || false
        };
    }

    addSensorName (e: any, { value }: { value: string }) {
        this.sensorNameOptions.push({ text: value, value });
        this.forceUpdate();
    }

    handleChecked (e: any, {checked, name}: any) {
        this.setState({
            [name] : checked
        });
    }

    renderConfigurationInput(
        configurations: any,
        changeHandler: any
    ) {
        return (
            <Tab.Pane>
                <ConfigurationsInput
                    name="configuration" 
                    initialValue={configurations} 
                    onChange={changeHandler} 
                />
            </Tab.Pane>
        );
    }

    renderSensorTypeIputs(
        possibleUnits: any,
        changeHandler: any,
        {   
            typedId,
            name,
            order,
            isStateBased,
            possibleStates,
            measurement,
            commUnit,
            maxValue,
            minValue,
            significantDifference,
            significantTimeDifference,
        }: any,

    ) {
        const me = this;
        return (
            <Tab.Pane>
            {(this.props.isNew) ?
                <Form.Field>
                <label>Code</label>
                <Form.Input 
                    placeholder="Code" 
                    onChange={this.handleAliasChange.bind(this)} 
                />
                <small>
                    unmodifiable code used by units to communicate data from sensorType communicate.

                </small>
                </Form.Field>
                : null
            }
            <Form.Field>
                <label>Name</label>
                <Form.Input 
                    required
                    placeholder="Name" 
                    name="name" 
                    defaultValue={name} 
                    onChange={changeHandler} 
                />
            </Form.Field>

            <Form.Field>
                <label>is State Based</label>
                <Form.Checkbox 
                    toggle 
                    name="isStateBased" 
                    checked={isStateBased}
                    onChange={this.handleChecked.bind(this)} 
                />
            </Form.Field>
            {isStateBased ?
                (
                    <Form.Field>
                        <label>Possible States</label>
                        <Form.Select
                            options={possibleStateOptions}
                            placeholder="All possible states"
                            search
                            selection
                            multiple
                            fluid
                            allowAdditions
                            name="possibleStates"
                            value={possibleStates}
                            onAddItem={(e, {value}: any) => {
                                possibleStateOptions.push({
                                    key: value,
                                    value: value,
                                    text: value
                                });
                                me.forceUpdate();
                            }}
                            onChange={changeHandler}
                        />
                    </Form.Field>
                ) 
                : 
                [
                    <Form.Field key="measurement">
                        <label>Measurement Type</label>
                        <Form.Select
                            options={Convert().measures()
                                .map((measure) => {
                                    return {
                                        key: measure,
                                        value: measure,
                                        text: measure
                                    };
                                })}
                            placeholder="Select what sensor measures"
                            selection
                            fluid
                            name="measurement"
                            value={measurement}
                            onChange={changeHandler}
                        />
                    </Form.Field>,
                    <Form.Field key="commUnit">
                        <label>Measurement Unit communicated by device</label>
                        <Form.Select
                            disabled={measurement === ''}
                            options={possibleUnits}
                            placeholder="select a unit device communicates with."
                            selection
                            fluid
                            name="commUnit"
                            value={commUnit}
                            onChange={changeHandler}
                        />
                    </Form.Field>,
                    <Form.Field key="minValue">
                        <label>Minimum Comm Value</label>
                        <Form.Input 
                            placeholder="Minimum Value" 
                            name="minValue" 
                            defaultValue={minValue} 
                            onChange={changeHandler} 
                        />
                        <small>
                            Minimum communicated value below which sensor is considered faulty
                        </small>
                    </Form.Field>,
                    <Form.Field key="maxValue">
                        <label>Maximum Comm Value</label>
                        <Form.Input 
                            placeholder="Maximum Value" 
                            name="maxValue" 
                            defaultValue={maxValue} 
                            onChange={changeHandler} 
                        />
                        <small>
                            Maximum communicated value above which sensor is considered faulty
                        </small>
                    </Form.Field>,
                    <Form.Field key="significantDifference">
                        <label>Significant Difference</label>
                        <Form.Input 
                            placeholder="Significant Difference" 
                            name="significantDifference" 
                            defaultValue={significantDifference} 
                            onChange={changeHandler} 
                        />
                        <small>
                            Ignorable change difference, to increase the performance.
                        </small>
                    </Form.Field>,
                    <Form.Field key="significantTimeDifference">
                        <label>Significant Time Difference (in minutes)</label>
                        <Form.Input 
                            placeholder="Significant Time Difference" 
                            name="significantTimeDifference" 
                            defaultValue={significantTimeDifference} 
                            onChange={changeHandler} 
                        />
                        <small>
                            The time difference beyond which the value is updated 
                            even if it haven't changed significantly.
                        </small>
                    </Form.Field>

                ]
            }
          </Tab.Pane>
        );
    }

    renderConditionalState(
        changeHandler: any,
        { 
            possibleStates,
            conditionalState 
        }: any
    ) {
        return (
            <Tab.Pane>
                <ConditionalState 
                    name="conditionalState"
                    isStateBased={this.state.isStateBased}
                    possibleStates={possibleStates}
                    onChange={changeHandler}
                    initialValue={conditionalState}
                />
            </Tab.Pane>
        );
    }

    render() {
        const changeHandler = this.handleChange.bind(this);
        const possibleUnits = Convert().possibilities(this.state.measurement)
            .map((unit) => {
                return {
                    key: unit,
                    value: unit,
                    text: unit
                };
            });

        const submitHandler = this.handleSubmit.bind(this);
        const tabs = [
            { 
                menuItem: 'SensorType Details', 
                render: () =>  this.renderSensorTypeIputs.apply(this, [possibleUnits, changeHandler, this.state])
            },
            {
                meanuItem: 'Conditional State',
                render: () => this.renderConditionalState.apply(this, [changeHandler, this.state])
            },
            { 
                menuItem: 'Configurations', 
                render: () =>  this.renderConfigurationInput.apply(this, [this.state.configurations, changeHandler])
            },
        ];

        return(
            <Modal
                closeIcon
                size="fullscreen" 
                open={true}
                onClose={this.handleClose.bind(this)}
                className="standard-padding center-margin tb-margin"
                style={{
                    marginTop: 10, 
                    marginLeft: 'auto', 
                    marginRight: 'auto',
                    padding: '21px',
                    boxSizing: 'content-box',
                    overflowY: 'scroll'
                }}
                dimmer="inverted"
                closeOnDimmerClick={true}
            >
                <Modal.Header>
                    Editing SensorType {this.state.name}
                </Modal.Header>
                <Form 
                    onSubmit={submitHandler}
                >
                    <Modal.Content>
                        <Modal.Description className="top-margin">
                            <Tab panes={tabs} />
                        </Modal.Description>
                    </Modal.Content>
                    <Modal.Actions>
                        <Form.Button primary float="right" className="top-margin">
                            Submit <Icon name="chevron right"/>
                        </Form.Button>
                    </Modal.Actions>
                </Form>
            </Modal>
        );
    }

    handleChange(
        e: any, 
        { 
            name, value 
        }: {
            name: string, 
            value: any
        }
    ) {
        this.setState({ [name]: value });
    }

    handleAliasChange(e: any, { value }: any) {
        this.setState({ typedId : `st:${value}:${this.typedUUID}`});
    }

    handleSubmit = (event: any) => {
        if (event.keyCode !== 13) {
            this.resolveRow(this.state as any);
        }
    }

    handleClose = () => {
        this.rejectRow({ isNormal: true, typedId: this.typedUUID});
    }
}


// WEBPACK FOOTER //
// ./src/container/SensorType/SensorTypeEdit.tsx